export default __webpack_public_path__ + "a10c59939c3e856025b3177d3f59bc1a.png";